import { GuestPageVisibilityMode } from "@/lib/gql/__generated__/graphql";

/**
 * 「検索に表示しない」のスイッチから、送る公開状態を決める
 *
 * オンは検索に表示しない（UNLISTED）。
 * オフは、保存済みの値が未設定・公開ならその値に戻す（未設定を公開で上書きせず、元に戻したときに未保存の扱いにしない）。それ以外は公開（PUBLIC）。
 * @param isUnlisted スイッチがオンか
 * @param savedVisibility 保存済みの公開状態
 */
export const resolveVisibility = (
	isUnlisted: boolean,
	savedVisibility: GuestPageVisibilityMode | undefined,
): GuestPageVisibilityMode => {
	if (isUnlisted) {
		return GuestPageVisibilityMode.Unlisted;
	}
	if (savedVisibility === GuestPageVisibilityMode.Unset || savedVisibility === GuestPageVisibilityMode.Public) {
		return savedVisibility;
	}
	return GuestPageVisibilityMode.Public;
};
